<div id="app-toolbar-account">
    <p-button [id]="'toolbar-account-btn'" (onClick)="profileMenu.toggle($event)">
        <span>
            <p id="nav-current-user-name">{{ currentUserShortName() }}</p>
            <p id="nav-current-user-role">ADMIN</p>
        </span>
        <span id="user-avatar-container">
            <app-user-avatar></app-user-avatar>
        </span>
    </p-button>

    <p-popover #profileMenu [styleClass]="'action-item-menu-user'" class="action-item-menu" [focusOnShow]="true">
        <app-menu-profile (mouseleave)="hideOverlay()"></app-menu-profile>
    </p-popover>
</div>
